import { render, staticRenderFns } from "./VacancyCandidatesSelected.vue?vue&type=template&id=2066ad96&scoped=true"
import script from "./VacancyCandidatesSelected.vue?vue&type=script&lang=js"
export * from "./VacancyCandidatesSelected.vue?vue&type=script&lang=js"
import style0 from "./VacancyCandidatesSelected.vue?vue&type=style&index=0&id=2066ad96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2066ad96",
  null
  
)

export default component.exports